const { svgToCanvas } = require('../../../helpers/svgToImage');

(function ($) {
  $.fn.extend({
    colorpicker: function (options) {
      const svgCanvas = INKIVE.Tool.getInstance().editor.canvas;
      const svgroot = $('#svgcanvas').find('#svgroot')[0];
      let svgcontent;
      let zoom;
      let rulersAndGuidesVisible;

      let screenshotCanvas = null;
      let $jpickerWrapper = null;
      let $clickedButton = null;
      let $eyeDropperPreviewContainer = null;
      let selectedElement = [];
      let isInline;
      let colorButtonType;
      let parent = null;

      options = $.extend({
        defaultColor: null,
        onLoad: $.noop,
        onClick: $.noop,
        onCancel: $.noop,
        onChange: $.noop,
        onSubmit: $.noop,
        skipClearSelection: true
      }, options);

      function close () {
        toggleEyeDropper(false);
        $('#jpickerOverlay, #jpickerWrapper, .eye-dropper-preview-container').remove();

        rulersAndGuidesVisible && svgCanvas.runExtensions('showRulersAndGuides', {});
      }

      function selectedEyeDropperColor (imageData) {
        imageData = imageData || [256, 256, 256];

        const rgbToHex = function (r, g, b) {
          return ((r << 16) | (g << 8) | b).toString(16);
        };

        const $eyeDropperContainer = $('.eye-dropper-preview-container');
        const hex = ('000000' + rgbToHex(imageData[0], imageData[1], imageData[2])).slice(-6);
        $eyeDropperContainer.find('.eye-dropper-preview span').css('background-color', '#' + hex);

        $eyeDropperContainer.find('.eye-dropper-input').val(hex);
        $jpickerWrapper.find('.Text input').val(hex);
      }

      function toggleEyeDropper (disable) {
        if (disable) {
          try {
            const isLibrary = $clickedButton.find('.library-colors-container').is(':visible');
            const $body = $('body');
            $eyeDropperPreviewContainer = $('<div data-is-library=' + isLibrary + '' +
            ' class="eye-dropper-preview-container">' +
            '<input type="text" maxlength="6" class="eye-dropper-input"  />' +
            '<div class="eye-dropper-preview"><span></span></div>' +
            '<input type="button" class="cancel-color-picker" value="' +
            INKIVE.TranslateHelper.translate('general.cancel') +
            '"/>' +
            '</div>');

            $('#jpickerOverlay').unbind();

            $eyeDropperPreviewContainer.find('.cancel-color-picker').on('click', function () {
              close();
              selectedElement.length === 1 && svgCanvas.addToSelection(selectedElement, true);
              $('[data-action="colormap-circle"][type=' + colorButtonType + ']').trigger('click');
              if (isLibrary) {
                $clickedButton.find('.template-colors-container').hide();
                $clickedButton.find('.library-colors-container').show();
              }
            });

            const $loader = $(INKIVE.TemplatesHelper('modal_loader'));
            $loader.addClass('screenshot-temp-canvas-loader');

            $('#svgcanvas').after($loader);

            parent = $jpickerWrapper.parent();
            $jpickerWrapper.parents('.ui-dropdown').length &&
            $jpickerWrapper.appendTo($body);

            $jpickerWrapper.hide();

            options.skipClearSelection || svgCanvas.clearSelection();
            const button = document.querySelector('[data-action="colormap-circle"][type=' + colorButtonType + ']');
            if (button) button.click();

            $body.append($eyeDropperPreviewContainer);

            INKIVE.Tool.disableUI();
            $('#pages-panel').find('.zoom-wrapper').addClass('disabled');
          } catch (error) {
            console.error(error);
            return toggleEyeDropper(false);
          }
        } else {
          parent && parent.append($jpickerWrapper);
          $jpickerWrapper.show();
          INKIVE.Tool.enableUI();
          $('.screenshot-temp-canvas-loader').remove();
          $(svgroot).find('.pageLoader').remove();
          $(screenshotCanvas).remove();
          $(svgroot).find('#svgcontent > .main').show();

          $('#pages-panel').find('.zoom-wrapper').removeClass('disabled');
          $eyeDropperPreviewContainer && $eyeDropperPreviewContainer.remove();
        }
      }

      function renderCanvasCallback () {
        _.delay(function () {
          $(svgroot).find('#svgcontent > .main').hide();
          $(screenshotCanvas).removeClass('hidden');
          $('.screenshot-temp-canvas-loader').remove();
          $('#jpickerOverlay').remove();

          const context = screenshotCanvas.getContext('2d');

          $(screenshotCanvas).on('mousemove', function (event) {
            const x = parseInt((event.pageX - $(this).offset().left));
            const y = parseInt((event.pageY - $(this).offset().top));
            const imageData = context.getImageData(x, y, 1, 1).data;
            selectedEyeDropperColor(imageData);
          });

          $(screenshotCanvas).on('mouseout', function () {
            selectedEyeDropperColor();
          });

          $(screenshotCanvas).on('click', function () {
            $jpickerWrapper.find('.Ok').trigger('click');
            $('[data-action="colormap-circle"][type=' + colorButtonType + ']').trigger('click');
          });
        }, 100);

        return false;
      }

      async function generateScreenshotCanvas () {
        const width = svgCanvas.contentW * zoom;
        const height = svgCanvas.contentH * zoom;

        screenshotCanvas = (await svgToCanvas(svgcontent.cloneNode(true), {
          pageId: INKIVE.Tool._current_design_id,
          useTransparentBackground: false,
          width,
          height,
          quickMode: true
        })).canvas;
        screenshotCanvas.className = 'screenshot-temp-canvas hidden';

        $(screenshotCanvas).css('top', $(svgcontent).attr('y') * zoom);
        $(screenshotCanvas).css('left', $(svgcontent).attr('x') * zoom);

        $(screenshotCanvas).insertAfter($('#svgcanvas')[0]);

        const canvas = INKIVE.Tool.getInstance().editor.canvas;
        const selectedElements = canvas.getSelectedElems();
        selectedElements.forEach((element) => {
          const selector = canvas.selectorManager.requestSelector(element);
          selector.selectorGroup.setAttribute('display', 'none');
        });
        renderCanvasCallback();
      }

      function startEyeDropper () {
        svgcontent = $('#svgcontent')[0];
        zoom = INKIVE.EditorFacade.handle('zoom', 'get');
        // During color picking, svgroot is hidden and rules can not be updated
        rulersAndGuidesVisible = svgCanvas.runExtensions('isRulersAndGuidesShown', {});
        rulersAndGuidesVisible && svgCanvas.runExtensions('hideRulersAndGuides', {});
        toggleEyeDropper(true);
        generateScreenshotCanvas();
        return false;
      }

      return this.each(function () {
        options.onLoad($(this));
        isInline = options.isInline;
        const $button = $(this);
        const input = $(this).find('[name="hex"]');

        selectedElement = options.selectedElement && options.selectedElement.length
          ? options.selectedElement
          : _.clone(svgCanvas.getSelectedElems());

        const renderColorPicker = function () {
          _.delay(function () {
            const $eyeDropper = $('.eye-dropper-preview-container');
            $eyeDropper.length && $eyeDropper.remove();
          }, 1000);

          const hex = input.val() || options.defaultColor;

          $jpickerWrapper = $('<div id="jpickerWrapper' +
            (isInline
              ? $button.parents('a').attr('type')
              : '') + '"/>');

          if (isInline) {
            $button.append($jpickerWrapper);
          } else {
            options.skipClearSelection || svgCanvas.clearSelection();

            $jpickerWrapper.addClass('addmore-color-picker');

            $('body').append('<div id="jpickerOverlay"></div>', $jpickerWrapper);

            $('#jpickerOverlay').on('click', function () {
              $jpickerWrapper.find('.Cancel').trigger('click');
            });
          }

          $jpickerWrapper.jPicker({
            images: {
              clientPath: INKIVE.C.BASE_URL + 'assets/css/editor/jpicker/'
            },
            color: {
              active: new $.jPicker.Color({ hex })
            }
          },
          // submit
          function (color, context) {
            const all = color.val('all');
            let hex = ((all && '#' + all.hex) || 'none');
            const $eyeDropperContainer = $('.eye-dropper-preview-container');

            if ((hex === '#FFFFFF' || $eyeDropperContainer.length) &&
                $jpickerWrapper.find('.Text input').val()) {
              hex = '#' + $jpickerWrapper.find('.Text input').val();
            }
            close($(this));
            options.onSubmit(hex, context, $eyeDropperContainer.data('is-library'));
            if (isInline) {
              return false;
            }
          },
          // change
          function (color, context) {
            const all = color.val('all');
            const hex = ((all && '#' + all.hex.toUpperCase()) || 'none');

            input.val(hex);
            $jpickerWrapper.find('.selected-color span').css('background-color', '#' + hex);
            input.trigger('change');

            options.onChange(hex, context);
          },
          // cancel
          function (color, context) {
            const all = color.val('all');
            const hex = ((all && '#' + all.hex) || all);

            close($(this));

            input.val(hex);
            input.trigger('change');

            options.onCancel(hex, context);
          });

          $clickedButton = $button.closest('a');

          $jpickerWrapper.one('color-picker-loaded', function () {
            const $input = $jpickerWrapper.find('input.Hex');
            const selectedColor = $clickedButton.find('input[type=hidden]').val() || '#FFFFFFF';

            $input.val(selectedColor.replace('#', ''));
            $input.trigger('keyup');
            $jpickerWrapper.find('.selected-color span').css('background-color', selectedColor);

            colorButtonType = $clickedButton.attr('type');

            $jpickerWrapper.find('.eye-dropper').on('click', startEyeDropper);
            $jpickerWrapper.find('.cancel-color-picker').one('click', function () {
              $jpickerWrapper.find('.Cancel').trigger('click');
            });
          });
        };

        if (isInline) {
          renderColorPicker();
          $button.on('click', function () {
            return false;
          });
        } else {
          $button.on('click', renderColorPicker);
          options.onClick($(this));
        }
      });
    }
  });
})(jQuery);
